module.exports = __webpack_public_path__ + "static/img/sy3.7fed2c3d.png";